export default __webpack_public_path__ + "static/media/modal_update_profile.35b7d106.png";